import { iconFilterInline } from 'components/icons/iconFilterInline';
import type { DefaultItem } from 'uikit';

import {
    ChapterEnum,
    ContragentTypeEnum,
    MtrRecordStatusEnum,
    MtrTypeEnum,
    RatioRecordStatusEnum,
    RatioTypeEnum,
    UerClassifierEnum,
    UerRecordStatusEnum,
    WorkInSumEnum,
    WorkOrderChangeStatusEnum,
} from './gql/graphql';

export const FIELD_WIDTH = 675;

export const mtrDictionary = {
    CONTRACTOR_MATERIAL: 'Материалы Подрядчика',
    CONTRACTOR_EQUIPMENT: 'Оборудование Подрядчика',
    CUSTOMER_MATERIAL: 'Материалы Заказчика',
    CUSTOMER_EQUIPMENT: 'Оборудование Заказчика',
};

export const AG_GRID_ICON_SETUP = {
    filter: iconFilterInline,
};

export const SupplyByValue: Record<string, string> = {
    [ContragentTypeEnum.Contractor]: 'Подрядчик',
    [ContragentTypeEnum.Customer]: 'Заказчик',
};

export const MtrTypeValue: Record<string, string> = {
    [MtrTypeEnum.Material]: 'Материал',
    [MtrTypeEnum.Equipment]: 'Оборудование',
};

export const MtrStatusValue: Record<string, string> = {
    [MtrRecordStatusEnum.ContractCondition]: 'Условие договора',
    [MtrRecordStatusEnum.AdditionalCondition]: 'Условие ДС',
    [MtrRecordStatusEnum.NewRecord]: 'Новая запись',
    [MtrRecordStatusEnum.Draft]: 'Черновик',
};

export const FactorGroupName: Record<string, string> = {
    [RatioTypeEnum.ConstraintCoef]: 'Коэф. стесненности',
    [RatioTypeEnum.TechPartCoef]: 'Коэф.тех.части',
    [RatioTypeEnum.DismantlingCoef]: 'Коэф. на демонтаж',
};

export const FactorStatusValue: Record<string, string> = {
    [RatioRecordStatusEnum.ContractCondition]: 'Условие договора',
    [RatioRecordStatusEnum.AdditionalCondition]: 'Условие ДС',
    [RatioRecordStatusEnum.NewRecord]: 'Новая запись',
    [RatioRecordStatusEnum.Draft]: 'Черновик',
};

export const FactorAppliesToLinkValue: Record<string, string> = {
    [RatioRecordStatusEnum.ContractCondition]: 'Условие договора',
    [RatioRecordStatusEnum.AdditionalCondition]: 'Условие ДС',
    [RatioRecordStatusEnum.NewRecord]: 'Новая связь',
    [RatioRecordStatusEnum.Draft]: 'Черновик',
};

export const UerChapter: Record<string, string> = {
    [ChapterEnum.Chapter1_7]: '1-7',
    [ChapterEnum.Chapter8]: '8',
    [ChapterEnum.Chapter9]: '9',
};

export const WorkOrderChapterMap: Record<ChapterEnum, string> = {
    [ChapterEnum.Chapter1_7]: 'Глава 1-7',
    [ChapterEnum.Chapter8]: 'Глава 8',
    [ChapterEnum.Chapter9]: 'Глава 9',
    [ChapterEnum.LimitedCosts]: 'Лимитированные',
    [ChapterEnum.Others]: 'Прочие',
};

export const UerClassifier: Record<string, string> = {
    [UerClassifierEnum.Construction]: 'Строительные',
    [UerClassifierEnum.Mounting]: 'Монтажные',
    [UerClassifierEnum.Transportation]: 'Транспортировка + ПРР',
    [UerClassifierEnum.Manufacture]: 'Изготовление',
    [UerClassifierEnum.Vzis]: 'ВЗиС',
    [UerClassifierEnum.Commissioning]: 'ПНР',
    [UerClassifierEnum.SnowRemoval]: 'Уборка снега',
    [UerClassifierEnum.PileTesting]: 'Испытание свай',
    [UerClassifierEnum.TypeExclusionOrAdd]: 'Исключение/добавление',
    [UerClassifierEnum.Disassembly]: 'Демонтаж',
    [UerClassifierEnum.RoadMaintenance]: 'Ремонт и содержание дорог',
    [UerClassifierEnum.Reclamation]: 'Рекультивация нарушенных земель',
};

export const UerStatus: Record<string, string> = {
    [UerRecordStatusEnum.ContractCondition]: 'Условие договора',
    [UerRecordStatusEnum.AdditionalCondition]: 'Условие ДС',
    [UerRecordStatusEnum.NewRecord]: 'Новая запись',
    [UerRecordStatusEnum.Draft]: 'Черновик',
};

export const WorkOrderChangeStatusProps: Record<WorkOrderChangeStatusEnum, DefaultItem> = {
    [WorkOrderChangeStatusEnum.OnFormation]: { label: 'На формировании', id: WorkOrderChangeStatusEnum.OnFormation },
    [WorkOrderChangeStatusEnum.Approving]: { label: 'На согласовании', id: WorkOrderChangeStatusEnum.Approving },
    [WorkOrderChangeStatusEnum.Approved]: { label: 'Согласован', id: WorkOrderChangeStatusEnum.Approved },
};

export const WorkInSumTitles = {
    [WorkInSumEnum.NotParticipate]: '0',
    [WorkInSumEnum.ParticipateWithRatio]: 'Ф с коэффициентом',
    [WorkInSumEnum.Participate]: 'Ф',
};

export const workInSumEnumItems = [
    {
        id: WorkInSumEnum.NotParticipate,
        label: '0',
    },
    {
        id: WorkInSumEnum.ParticipateWithRatio,
        label: 'Ф с коэффициентом',
    },
    {
        id: WorkInSumEnum.Participate,
        label: 'Ф',
    },
];
